export { auth } from "./setup";
export {
  createMagicLink,
  processMagicLink,
  signInWithEmail,
  sendPasswordReset,
} from "./connections";
